export const environment = {
  production: false,
  url:'https://sistema-inventarios-backend-qa.coopertsmith.com.mx/gmd/',
  cognito: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_tGsVo9MOT',
    signUpVerificationMethod: 'code',
    userPoolWebClientId: '10o8grm6ka0af9f3ep7vnel3uf',
    oauth: {
      domain: 'https://gmd-altamira-qa.auth.us-east-1.amazoncognito.com',
      redirectSignIn: 'https://sistema-inventarios-qa.coopertsmith.com.mx/ship-list',
      redirectSignOut: 'https://sistema-inventarios-qa.coopertsmith.com.mx/login',
      responseType: 'code',
    },
  }
};
